export const categories = [
  {
    slug: "comedy",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    description: "轻松解压的搞笑短片、街头采访与综艺名场面，随时随地笑出声。",
    gradient: "from-primary-500 to-accent-500",
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-film-line",
    description: "记录自然、人文与时代的真实影像，感受镜头背后的世界。",
    gradient: "from-secondary-600 to-secondary-800",
  },
  {
    slug: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    description: "现场演出、民谣电音与纯音乐合集，用声音陪伴每一个时刻。",
    gradient: "from-accent-500 to-primary-500",
  },
  {
    slug: "entertainment",
    name: "娱乐",
    icon: "ri-star-smile-line",
    description: "综艺、访谈与舞台高光片段，掌握每日娱乐热点。",
    gradient: "from-primary-600 to-primary-800",
  },
  {
    slug: "movie",
    name: "影视",
    icon: "ri-movie-2-line",
    description: "短片、经典片段与独立电影推荐，快速找到下饭好片。",
    gradient: "from-secondary-500 to-primary-700",
  },
  {
    slug: "tech",
    name: "科技",
    icon: "ri-cpu-line",
    description: "前沿科技趋势、智能生活体验与产品解析，看懂未来方向。",
    gradient: "from-accent-600 to-primary-700",
  },
  {
    slug: "life",
    name: "生活",
    icon: "ri-leaf-line",
    description: "美食、旅行与居家技巧，把日常过得更有滋味。",
    gradient: "from-accent-400 to-accent-700",
  },
  {
    slug: "sports",
    name: "体育",
    icon: "ri-basketball-line",
    description: "赛事集锦、极限运动与经典进球，重温热血瞬间。",
    gradient: "from-primary-500 to-secondary-700",
  },
];